import React from 'react';
import { injectIntl } from 'react-intl';
import { InfoBox, Box } from '@landtrustinc/design-system';
import usePropertyRules from '../../hooks/usePropertyRules';

const SectionPropertyRules = ({ publicData, intl }) => {
  const { policies } = publicData || {};
  const { features } = usePropertyRules({ policies, intl });

  if (!features || features.length === 0) {
    return null;
  }

  return (
    <Box mb="var(--spacing-5)">
      <InfoBox
        heading={intl.formatMessage({ id: 'ListingPage.propertyRulesTitle' })}
        features={features}
      />
    </Box>
  );
};

export default injectIntl(SectionPropertyRules);
